<template>
    <span class="d-inline-block mw-100">
        <template v-if="!data.asrOptions">
            <span>N/A</span>
        </template>
        <template v-if="data.asrOptions">
            <span ref="trigger" class="d-inline-block mw-100 text-truncate">
                {{ generateOptionsString() }}
            </span>
            <b-popover :target="popoverTarget" triggers="hover">

                <b-list-group>
                    <b-list-group-item v-for="(option, key) in data.asrOptions" v-bind:key="key">
                        <div>{{ $t('Entities.AsrOptions.' + capitalizeFirstLetter(key)) }} : {{ (option === true)?'Yes': (option === false)?'No': option }}</div>
                    </b-list-group-item>
                </b-list-group>

            </b-popover>
        </template>
    </span>
</template>

<script>

    //import axios from 'axios';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';


    export default {
        name: 'AsrSelectedOptionsColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                asrOptionsList: null,
            };
        },

        methods: {
            popoverTarget: function () {
                return this.$refs.trigger;
            },
            onPopoverShow: function () {

                this.asrOptionsList = this.data.asrOptionsList;

            },
            capitalizeFirstLetter: function (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },

            generateOptionsString: function () {
                var optionString = "";
                var lastValue = null;
                if (this.data.asrOptions != null) {
                    var assignedValues = [];
                    if (this.data.asrOptions.dictatedPunctuationMode && this.data.asrOptions.automaticPunctuationMode) {
                        optionString = this.$t('Entities.AsrOptions.DictatedAutomaticPunctuationMode');
                        assignedValues.push(...["dictatedPunctuationMode", "automaticPunctuationMode"]);
                        lastValue = "AutomaticPunctuationMode";
                    }
                    else if (!this.data.asrOptions.dictatedPunctuationMode && !this.data.asrOptions.automaticPunctuationMode) {
                        optionString = this.$t('Entities.AsrOptions.DictatedAutomaticPunctuationModeFalse');
                        assignedValues.push(...["dictatedPunctuationMode", "automaticPunctuationMode"]);
                        lastValue = null;
                    }

                    Object.keys(this.data.asrOptions).forEach(key => {
                        if (assignedValues.includes(key)) return;

                        var falseOption = this.data.asrOptions[key] === false;
                        var refAppend = falseOption ? 'False' : '';
                        if (typeof this.data.asrOptions[key] == "string")
                            refAppend = this.data.asrOptions[key];
                        optionString += (lastValue != null) ? ', ' : '';

                        var appendString = this.$t('Entities.AsrOptions.' + this.capitalizeFirstLetter(key) + refAppend);
                        lastValue = appendString;
                        optionString += appendString;

                        assignedValues.push(key);
                    });
                }
                return optionString;
            },
            //    loadStaffWorkItemAssignments: function () {
            //        var url = this.$urlHelper.getApiUrl('staffworkitemassignment', 'byworkitem', [this.data.workItemId]);
            //        axios
            //            .get(url)
            //            .then(response => {
            //                this.staffWorkItemAssignments = response.data;
            //            })
            //            .catch(ex => {
            //                var currentErrors = this.handleAxiosException(ex);
            //                this.showErrorsToast(currentErrors);
            //            });
            //    }
        }
    }
</script>